import { render, staticRenderFns } from "./UploadXlsx.vue?vue&type=template&id=7c3ab6e4&scoped=true"
import script from "./UploadXlsx.vue?vue&type=script&lang=js"
export * from "./UploadXlsx.vue?vue&type=script&lang=js"
import style0 from "./UploadXlsx.vue?vue&type=style&index=0&id=7c3ab6e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3ab6e4",
  null
  
)

export default component.exports